import naja from "naja"

// Odchytneme všechny AJAXové požadavky vyvolané elementem který má nastaven data-confirm a požadavek provedeme pouze pokud je confirm potvrzen
naja.uiHandler.addEventListener('interaction', (e) => {
    if(!confirm(e.detail.element)) {
        e.preventDefault()
    }
})

export default function confirm(element)
{
    let confirmMessage = element.dataset.confirm
    if(confirmMessage) {
        return window.confirm(confirmMessage)
    }
    return true
}